import { useMemo } from 'react';

import { getAppPageConfig } from 'hb-react/frontoffice/utils/page';
import useFetchAppPages from 'hb-react/shared/hooks/useFetchAppPages';

export const useConfig = ({ topic, routes }) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const appPages = topic?.app_pages || useFetchAppPages();
  const appPageConfig = getAppPageConfig('mentorships', null, appPages);

  const config = useMemo(
    () => ({
      custom: {
        page: appPageConfig,
      },
      routes,
      topic,
    }),
    [appPages, routes],
  );

  return { appPages, config };
};
